import { alpha, Theme } from '@mui/material';
export default {
    section: {
        borderBottom: (theme: Theme) => `1px solid ${alpha(theme.palette.text.primary, 0.08)}`,
    },
    sectionTitle: {
        fontWeight: 600,
        p: 1.5,
        color: 'text.primary',
        '&:hover': {
            cursor: 'pointer',
            opacity: 0.85,
            color: 'primary.main',
        },
        '.section--expanded &': {
            boxShadow: (theme: Theme) => `0px 2px 4px 0px ${alpha(theme.palette.text.primary, 0.08)}`,
        },
    },
    sectionTitleLabel: {
        flexGrow: 1,
    },
    sectionTitleIcon: {
        flexShrink: 0,
        ml: 1,
        fontSize: '16px',
        display: 'inline-flex',
        mt: '1px',
    },
    sectionControlsContainer: {
        p: 1.5,
        backgroundColor: (theme: Theme) => alpha(theme.palette.text.primary, 0.02),
        '.section--collapsed &': {
            display: 'none',
        },
    },
    propertyContainer: {},
    propertyTitle: {
        '&.design-variant--secondary': {
            display: 'block',
        },
    },
    propertyControlHolder: {},
};
